define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpMessagingEngagementHistoryTableAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryTableAdapter');

    // TODO: Add Global Dispose base on AppEvent for VisitorDisposed Event.

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var APPLICATION_TYPE = 'MessagingEngagementHistory';
    var logger = WebAgentLogger.getLogger(APPLICATION_TYPE);
    var engagementHistoryModel = "engagementsHistoryByVisitor";

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////
    var lpMessagingEngagementHistoryConsumerController = BaseController.extend(function lpMessagingEngagementHistoryConsumerController(options) {
        this.service = options.service;

        /**
         * Listen to Application event for Visitor Disposal.
         */
        lpTag.WebAgent.channel.bind(
            webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.name,
            webAgentStatics.COMMUNICATION_CHANNELS.AppEvents.events.beforeVisitorDisposed,
            _handleVisitorDispose.bind(this)
        );
    });

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    lpMessagingEngagementHistoryConsumerController.prototype.applicationType = APPLICATION_TYPE;

    /**
     * Fetch all visitor history if not available and set the data to the model.
     * @param reqObj
     */
    lpMessagingEngagementHistoryConsumerController.prototype.getChatHistory = function (reqObj) {
        logger.debug('Requesting Chat history for consumer id:' + reqObj.visitorId);
        var request = _createRequestObject(this, reqObj);
        this.service.getConsumerHistory(request);
    };

    /**
     * create a Request Object for the service.
     * @param context
     * @param reqObj
     * @returns {{consumerId: *, success: onSuccess, error: onError}}
     * @private
     */
    function _createRequestObject(context, reqObj) {
        return {
            consumerId: reqObj.visitorId,
            success: onSuccess,
            error: onError
        };

        function onSuccess(data) {
            logger.debug('consumer history success callback fired.');
            var result = {
                count: data.count,
                array: data.data,
                cSatStatistics: data.cSatStatistics,
                state: {
                    status: "fetched",
                    success: "ok",
                    itemsCount: data.count
                }
            };

            _setEngagementHistoryDataInModel(context,reqObj.visitorId, result);
        }
        function onError() {
            logger.debug('consumer history error callback fired');

            var result = {
                count: 0,
                array: [],
                state: {
                    status: "error",
                    itemsCount: 0
                }
            };
            _setEngagementHistoryDataInModel(context, reqObj.visitorId, result);
        }
    }

    /**
     * persist the data in the model.
     * @param context
     * @param visitorId
     * @param data
     * @private
     */
    function _setEngagementHistoryDataInModel(context, visitorId, data) {
        logger.debug('set engagement history data into model for visitorId: ' + visitorId);

        // setting the data into the model.
        context.model.set(engagementHistoryModel + '.' + visitorId, data);
        if (data.cSatStatistics) {
            context.model.set('userProfiles' + '.' + visitorId + '.cSat', data.cSatStatistics);
        }

    }

    /**
     * handler for disposing a visitor.
     * @param data - contain the visitor Id.
     * @param eventInfo - contain the event information.
     * @private
     */
    function _handleVisitorDispose(data, eventInfo) {
        if (data && data.visitorId) {
            // Removing All Data Related To the Visitor.
            this.model.removeKey(engagementHistoryModel + '.' + data.visitorId);
        }
    }


    /**
     * send a request to the service to fetch the data for the conversation.
     * @param {Object} options
     * @param {String} options.visitorId - the visitor id.
     * @param {String} options.chatId - the conversation id
     * @param {String} options.latestAgentId
     * @param {function} options.done - a callback indicating that this operation is done.
     */

    lpMessagingEngagementHistoryConsumerController.prototype.populateChatHistoryConversation = function (options) {
        var self = this,
            conversationId = options.chatId,
            visitorId = options.visitorId,
            latestAgentId = options.latestAgentId,
            contentToRetrieve = lpMessagingEngagementHistoryTableAdapter.CONTENT_BLOCKS.BASE,
            done = options.done,
            onError = options.error;

        var reqObj  = {
            searchType: lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.ByConversation,
            data: {conversationId :conversationId, latestAgentId: latestAgentId, contentToRetrieve: contentToRetrieve},
            error: onError,
            success:onSuccess
        };

        lpTag.WebAgent.amsEngagementHistoryController.service.searchEngagements(reqObj);


        function onSuccess(data){
            var lines =  data&& data.data && data.data[0] && data.data[0].chatData && data.data[0].chatData.chatInfo && data.data[0].chatData.chatInfo.events && data.data[0].chatData.chatInfo.events.event;
            var conversations = self.model.get(engagementHistoryModel + '.' + visitorId + '.array');
            for (var i = 0; i < conversations.length; i++) {
                if (conversations[i].data.conversationId === conversationId) {
                    conversations[i].transcript.line = lines;
                    break;
                }
            }
            self.model.set("images."+conversationId, setImageArray(lines) );
            self.model.set("audio."+conversationId, setAudioArray(lines) );

            done();
        }
        /**
         * Get the list of lines for the transcript object from the history events data.
         * @param conversationId
         * @returns {Array} - list of transcript line's
         * @private
         */




        function setImageArray(lines){
            var retArr = [];
            for(var i = 0; i<lines.length ; i++){
                if(lines[i].contentType === "hosted/file" && lines[i].isImage === true){
                    retArr.push(lines[i]);
                }
            }
            return retArr;
        }

        function setAudioArray(lines){
            var retArr = [];
            for(var i = 0; i<lines.length ; i++){
                if(lines[i].contentType === "hosted/file" && lines[i].isAudio === true){
                    retArr.push(lines[i]);
                }
            }
            return retArr;
        }
    };

    return lpMessagingEngagementHistoryConsumerController;

});
